var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning d-flex justify-content-between",attrs:{"role":"alert"}},[_c('span',[_c('strong',[_vm._v("Atenção: ")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_c('InfoIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }